export const REASON_ID = 'reason_id'
export const PAGE = 'page'
export const SIZE = 'size'
export const CALENDAR_ID = 'calendar_id'
export const STATUS = 'status'
export const TIME = 'time'
export const USER_ID = 'user_id'
export const VIEW_TYPE = 'view_type'
export const MODE = 'mode'
